<template>
  <div class="password-reset-page pt-5 mt-5">
    <div class="password-reset-content mt-5">
      <div class="text-center mb-4">
        <img src="@/assets/images/placeholder-logo.svg" alt="Logo" class="logo-image" />
        <h2 class="welcome-text mt-3">Recuperar contraseña</h2>
      </div>
      
      <PasswordResetForm />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import PasswordResetForm from '@/components/auth/PasswordResetForm.vue'

onMounted(() => {
  // seteo el titulo de la pagina
  // Título manejado por el router
})
</script>

<style scoped>
.password-reset-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f4f8, #e9ecef);
  padding: 20px;
}

.password-reset-content {
  width: 100%;
  max-width: 500px;
}

.logo-image {
  width: 120px;
  height: auto;
  animation: fadeIn 1s ease;
}

.welcome-text {
  font-size: 1.8rem;
  color: var(--black-color);
  font-weight: 600;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>